// MODEL : Report or Segment
//
// currently we don't have instances of this view used directly,
// but the Top10ReportDashboardItemView and KpiReportDashboardItemView views
// are sub-classing this one
//
define('app/dashboard/widgets/ReportDashboardItemView',['require','glu/layout','app/visualizations/FormatFactory','glu/dialog','hbs!./ReportDashboardItemView.hbs'],function(require) {

	'use strict';

	var Layout = require('glu/layout'),
		FormatFactory = require('app/visualizations/FormatFactory'),
		dialog = require('glu/dialog');

	return Layout.extend({
		className: 'dashboard-item dashboard-item-report',
		template: require('hbs!./ReportDashboardItemView.hbs'),

		initialize: function() {
			this.dateFormat = FormatFactory.formatterForType('DATETIME', {});
			// this will allow to use mock dialog in unit tests
			this.dialog = dialog;
			this.widgetName = 'Report';
		},

		attributes: function() {
			return {
				'data-id': 'item_' + this.model.id
			};
		},

		events: {
			'click .report-delete': 'deleteEntity'
		},

		serializeData: function() {
			return this;
		},

		id: function() {
			return this.model.id;
		},

		name: function() {
			return this.model.getName();
		},

		description: function() {
			return this.model.getDescription();
		},

		domainId: function() {
			return this.model.getDomainId();
		},

		canBeDeleted: function() {
			return this.model.canBeDeleted();
		},

		hide: function() {
			this.$el.fadeOut({
				complete: this.onHideComplete
			});
		},

		dateCreated: function() {
			return this.dateFormat(this.model.getDateCreated());
		},

		dateModified: function() {
			return this.dateFormat(this.model.getDateModified());
		},

		// for unit tests only
		onHideComplete: function() {},

		deleteEntity: function() {
			var self = this;
			var report = this.model;
			this.dialog.confirm('Are you sure you want to delete ' + this.widgetName.toLowerCase() + ' "' + this.name() + '" ?', 'Delete ' + this.widgetName, function(ok) {

				if (ok) {
					// Logic if 'Yes' is clicked
					report.destroy().then(
						function() {
							self.hide();
						}
					);
					return;
				}
			});
		},

		hasData: function() {
			return this.model.hasData();
		},

		noResultMessage: function() {
			return 'No results returned for current filters.';
		}
	});
});

